<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div>
    <v-row>
      <v-col class="py-2">
        <div class="text-h5 font-weight-bold black--text text-center">
          Pedido Número: {{ order.franchise.code }} -
          {{ order.code }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-1">
        <v-card class="mx-auto px-5 py-5" width="1300" outlined>
          <v-row>
            <v-col class="py-1" cols="12" xs="6" md="4">
              <strong
                >Cliente: {{ order.franchise.code }} -
                {{ order.franchise.name }}</strong
              >
            </v-col>
            <v-col class="py-1" cols="12" xs="6" md="3"></v-col>
            <v-col class="py-1" cols="12" xs="3" md="3"
              ><strong>Data Pedido:</strong></v-col
            >
            <v-col class="py-1" cols="12" xs="3" md="2"
              ><strong>{{ order.issuance_date }}</strong></v-col
            >
          </v-row>
          <v-row>
            <v-col class="py-1" cols="12" xs="6" md="4"
              >CNPJ: {{ order.franchise.document }}
            </v-col>
            <v-col class="py-1" cols="12" xs="6" md="3"
              >I. E.: {{ order.franchise.state_registration }}</v-col
            >
            <v-col class="py-1" cols="12" xs="3" md="3"
              >Data Desejada de Faturamento:</v-col
            >
            <v-col class="py-1" cols="12" xs="3" md="2">{{
              order.desired_date
            }}</v-col>
          </v-row>
          <v-row>
            <v-col class="py-1" cols="12" xs="6" md="4"
              >Email: {{ order.franchise.email }}
            </v-col>
            <v-col
              class="py-1"
              cols="12"
              xs="6"
              md="3"
              v-if="order.franchise.suframa"
              >Suframa: {{ order.franchise.suframa }}
            </v-col>
            <v-col class="py-1" cols="12" xs="6" md="3" v-else></v-col>
            <v-col class="py-1" cols="12" xs="3" md="3">
              Data Estimada de Faturamento:</v-col
            >
            <v-col class="py-1" cols="12" xs="3" md="2">{{
              order.estimate_date
            }}</v-col>
          </v-row>
          <v-row>
            <v-col class="py-1" cols="12" xs="6" md="4"
              >Tipo de Frete:
              <strong>{{ order.shipping_method }}</strong>
            </v-col>
            <v-col
              class="py-1"
              cols="12"
              xs="6"
              md="8"
              v-if="order.shipping_company"
              >Transportadora:
              <strong>{{ order.shipping_company.name }}</strong>
            </v-col>
            <v-col class="py-1" cols="12" xs="6" md="8" v-else></v-col>
          </v-row>
          <v-row>
            <v-col class="py-1" cols="12" xs="6" md="4">
              <span
                >Situação:
                <strong>{{ getNameStatusOrder(order.status) }}</strong></span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col class="px-0">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-row class="border-right-table">
                <v-col class="py-1"
                  ><label class="text-subtitle-2 text-weight-bold"
                    >Endereço de Entrega</label
                  >
                </v-col>
              </v-row>
              <v-row class="border-right-table">
                <v-col class="py-1" cols="12" xs="12" md="12"
                  >Logradouro: {{ address_delivery }}
                </v-col>
              </v-row>
              <v-row class="border-right-table">
                <v-col class="py-1" cols="12" xs="6" md="6"
                  >Bairro:
                  {{ order.franchise.delivery_neighborhood }}
                </v-col>
                <v-col class="py-1" cols="12" xs="6" md="6"
                  >Cidade: {{ order.franchise.delivery_city }}
                </v-col>
              </v-row>
              <v-row class="border-right-table">
                <v-col class="py-1" cols="12" xs="3" md="4"
                  >CEP: {{ order.franchise.delivery_zip_code }}
                </v-col>
                <v-col class="py-1" cols="12" xs="2" md="2"
                  >UF: {{ order.franchise.delivery_state }}
                </v-col>
                <v-col class="py-1" cols="12" xs="3" md="6"
                  >Telefone:
                  {{ order.franchise.billing_phone_number }}
                </v-col>
              </v-row>
              <v-row class="border-right-table">
                <v-col class="py-1" cols="12" xs="3" md="6"
                  >Contato:
                  {{ order.franchise.delivery_contact_name }}
                </v-col>
                <v-col class="py-1" cols="12" xs="2" md="6"
                  >Celular:
                  {{ order.franchise.delivery_cell_number }}
                </v-col>
              </v-row>
            </v-col>
            <v-col class="py-1">
              <v-row>
                <v-col class="py-1"
                  ><label class="text-subtitle-2 text-weight-bold"
                    >Endereço de Cobrança</label
                  ></v-col
                >
              </v-row>
              <v-row>
                <v-col class="py-1" cols="12" xs="12" md="12"
                  >Logradouro: {{ address }}
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1" cols="12" xs="6" md="6"
                  >Bairro:
                  {{ order.franchise.billing_neighborhood }}
                </v-col>
                <v-col class="py-1" cols="12" xs="6" md="6"
                  >Cidade: {{ order.franchise.billing_city }}
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1" cols="12" xs="3" md="4"
                  >CEP: {{ order.franchise.billing_zip_code }}
                </v-col>
                <v-col class="py-1" cols="12" xs="2" md="2"
                  >UF: {{ order.franchise.billing_state }}
                </v-col>
                <v-col class="py-1" cols="12" xs="3" md="6"
                  >Telefone:
                  {{ order.franchise.billing_phone_number }}
                </v-col>
              </v-row>
              <v-row class="">
                <v-col class="py-1" cols="12" xs="3" md="6"
                  >Contato:
                  {{ order.franchise.billing_contact_name }}
                </v-col>
                <v-col class="py-1" cols="12" xs="2" md="6"
                  >Celular:
                  {{ order.franchise.billing_cell_number }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="px-0">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-row>
                <v-col class="py-1">
                  <strong
                    >Fornecedor: {{ order.provider.code }} -
                    {{ order.provider.name }}</strong
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1" v-if="order.payment"
                  >Pagamento: {{ order.payment.name }}
                </v-col>
                <v-col class="py-1" v-else>Pagamento: </v-col>
                <v-col class="py-1">Desconto: {{ order.discount }}%</v-col>
              </v-row>
              <v-row>
                <v-col class="py-1"
                  >Telefone: {{ order.provider.phone_number }}
                </v-col>
                <v-col class="py-1"
                  >Contato: {{ order.provider.contact_name }}</v-col
                >
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="px-0">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-row>
                <v-col class="py-1" style="min-height: 50px">
                  <strong>Observação:</strong>
                  <p v-for="obs in order.observation">
                    <label>{{ obs.text }}</label>
                  </p>
                  <v-divider class="mt-3"></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1" style="min-height: 50px">
                  <strong>Observação Fornecedor:</strong>
                  <v-divider class="mt-3"></v-divider>
                  <p
                    v-for="obs in order.observation_default"
                    :class="`my-1 ${getStrongClassObservation(obs.type)}`"
                  >
                    <v-icon dense left :color="getIconColor(obs)"
                      >mdi-information</v-icon
                    >
                    {{ obs.observation }}
                  </p>
                  <v-divider class="mt-3"></v-divider>
                  <p v-for="obsP in order.observation_provider">
                    <label>{{ obsP.text }}</label>
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card class="mx-auto px-5 py-5" width="1300" outlined>
          <v-row>
            <v-col>
              <v-simple-table fixed-header dense height="650px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" colspan="8">
                        <span class="text-h5 font-weight-bold black--text"
                          >Produtos</span
                        >
                      </th>
                      <th></th>
                    </tr>
                    <tr>
                      <th class="text-left text-no-wrap">Categoria</th>
                      <th class="text-left text-no-wrap">Referencia</th>
                      <th class="text-left text-no-wrap">Material</th>
                      <th class="text-left text-no-wrap">Cor</th>
                      <th class="text-right text-no-wrap">Qtde.</th>
                      <th class="text-right text-no-wrap">Vr. Unitário</th>
                      <th class="text-right text-no-wrap">Vr. Desconto</th>
                      <th class="text-right text-no-wrap">Vr. Venda</th>
                      <th class="text-right text-no-wrap">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="item in products">
                      <template v-for="product in item.items">
                        <tr>
                          <td class="none-border-bottom">
                            {{ product.category }}
                          </td>
                          <td class="none-border-bottom">
                            {{ order.provider.code }}
                            {{ product.reference }}
                          </td>
                          <td class="none-border-bottom">
                            {{ product.material_code }}-{{ product.material }}
                          </td>
                          <td class="none-border-bottom">
                            {{ product.color_code }}-{{ product.color }}
                          </td>
                          <td class="none-border-bottom text-right">
                            <strong>{{ product.quantity }}</strong>
                          </td>
                          <td class="none-border-bottom text-right">
                            {{ product.price | currencyEuaToBr }}
                          </td>
                          <td class="none-border-bottom text-right">
                            {{ product.discount | currencyEuaToBr }}
                          </td>
                          <td class="none-border-bottom text-right">
                            {{ getPriceDiscount(product) | currencyEuaToBr }}
                          </td>
                          <td class="none-border-bottom text-right">
                            {{ product.total | currencyEuaToBr }}
                          </td>
                        </tr>
                        <tr class="">
                          <td
                            class="text-right none-border-bottom"
                            :index="item.id"
                          >
                            <strong>Grade:</strong>
                          </td>
                          <td colspan="7" class="none-border-bottom">
                            <div
                              class="box-grid"
                              v-for="size in item.tamanho"
                              :key="size"
                            >
                              {{ size }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-right">
                            <strong>Qtdes.:</strong>
                          </td>
                          <td colspan="7">
                            <div
                              class="box-quantity"
                              v-for="size in product.sizes"
                            >
                              {{ size }}
                            </div>
                          </td>
                        </tr>
                      </template>
                    </template>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th colspan="4" class="text-right font-weight-black">
                        Quantidade Total:
                      </th>
                      <th class="text-right">
                        {{ getSumQuantity() }}
                      </th>
                      <th colspan="3" class="text-right font-weight-black">
                        Valor Total:
                      </th>
                      <th class="text-right font-weight-black">
                        {{ getTotal() | currencyEuaToBr }}
                      </th>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    order: {},
    getNameStatusOrder: Function,
    getStrongClassObservation: Function,
    getIconColor: Function,
    getSumQuantity: Function,
    getTotal: Function,
    address_delivery: String,
    address: String,
    products: [],
  },
  methods: {
    getPriceDiscount(item) {
      return parseFloat(item.price) - parseFloat(item.discount);
    },
  },
};
</script>

<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
#styled-input {
  height: 40px;
  font-size: 20pt;
}
.compact-form .fs-12 {
  transform: scale(0.8);
  transform-origin: left;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
.border-right-table {
  border-right: 1px solid #ccc;
}
.none-border-bottom {
  border-bottom: 0px !important;
}
.order-by-products {
  width: 180px;
}
.box-grid {
  background-color: #010101;
  color: white;
  padding: 6px;
  margin: 4px;
  width: 30px;
  height: 30px;
  display: inline-block;
  text-align: center;
  font-weight: bold;
}
.box-quantity {
  background-color: #dfdfdf;
  color: black;
  padding: 6px;
  margin: 4px;
  width: 30px;
  height: 30px;
  display: inline-block;
  text-align: center;
  font-weight: bold;
}
</style>
